import React from 'react';
import * as colors from '../colorConstants';
import { SpinnerWrapper, SpinnerBackground } from './CustomSpinner.styles';

// TODO This spinner's styles are not done properly
// avoiding using this until they are corrected
export const CustomSpinner = (props) => {
  return (
    <React.Fragment>
      <SpinnerWrapper
        {...props}
        size={props.size || 10}
        color={props.color || colors.simplrBlue}
        data-testid={'customSpinner'}
      />
      {props.withBackground && <SpinnerBackground />}
    </React.Fragment>
  );
};

export default CustomSpinner;
